/**
 * @generated SignedSource<<642c3d33e174f011359216d3b6b2c1c5>>
 * @relayHash 87747e14238de77ee6b608c3fa7ceb25
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974

import type { ConcreteRequest, Query } from 'relay-runtime';
export type FavouriteContentShortcutListenerQuery$variables = {
  contentId: string;
};
export type FavouriteContentShortcutListenerQuery$data = {
  readonly contentOperations: {
    readonly id: string | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly metadata: {
      readonly currentuser: {
        readonly favourited: {
          readonly isFavourite: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    };
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type FavouriteContentShortcutListenerQuery = {
  response: FavouriteContentShortcutListenerQuery$data;
  variables: FavouriteContentShortcutListenerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
            "kind": "LinkedField",
            "name": "currentuser",
            "plural": false,
            "selections": [
              {
                "concreteType": "FavouritedSummary",
                "kind": "LinkedField",
                "name": "favourited",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "alias": "contentOperations",
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FavouriteContentShortcutListenerQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FavouriteContentShortcutListenerQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "87747e14238de77ee6b608c3fa7ceb25",
    "id": "e83b49a9735e1da791b68dbd15f5e410431ed040eea10f46b8a29d51d7d64974",
    "metadata": {},
    "name": "FavouriteContentShortcutListenerQuery",
    "operationKind": "query",
    "text": "query FavouriteContentShortcutListenerQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "6ff7d72d61283f21b554c99c3279a8f9";

export default node;
